import { useCallback } from 'react';

import { useNavigation } from '@react-navigation/native';

import { useUserStore } from '@/hooks/use-user-store';
import { useCoreNavigation, useRafNavigation } from '@/navigation/navigation';
import { isWeb } from '@/utils/constants-platform-specific';

export const usePromotionsNavigation = () => {
    const { goToRaf } = useRafNavigation();
    const { openLaunch } = useCoreNavigation();
    const guest = useUserStore(state => state.guest);
    const userId = useUserStore(state => state.profile.sub);
    const navigation = useNavigation();

    const goToPromo = useCallback(
        (promoUid: string, external_url?: string | null) => {
            if (isWeb && guest) {
                //Do not allow web guest users to open promotions in a new tab, instead redirect to sign in / register
                //For APP users, this will be caught by the `container.tsx` in `handleStateChange`
                //and not allow guest users to navigate to protected routes, but for web this usually opens a new tab,
                //so we must handle it differently
                openLaunch();
                return;
            }
            if (!promoUid) {
                return;
            }
            if (external_url) {
                if (external_url === 'invite-friends') {
                    // Invite friends is a special case where we navigate to the RAF page
                    goToRaf();
                    return;
                }
                const uri = external_url + '?CustID=' + userId;
                navigation.navigate('ModalWebView', { uri });
                return;
            }
            navigation.navigate('PromoDetails', { promoId: promoUid });
        },
        [goToRaf, guest, navigation, openLaunch, userId]
    );

    return { goToPromo };
};
